export const uiSchema = t => {
  return {
    enableResetPasswordRequirement: {
      "ui:widget": "toggle",
      "ui:options": {
        labels: [
          { label: t("ENABLE"), value: true },
          { label: t("DISABLE"), value: false },
        ],
      },
    },
    passwordResetFrequencyEmployee: {
      "ui:widget": "number-input",
    },
    passwordResetFrequencyManager: {
      "ui:widget": "number-input",
    },
    activeTo: {
      "ui:widget": "hidden",
    },
    activeFrom: {
      "ui:widget": "hidden",
    },
    isEnabled: {
      "ui:widget": "hidden",
    },
  };
};
